import { fieldId } from '../../field-id.model';

export class TooltipModel {
  constructor(
    public show = true,
    public field_ids: fieldId[] = [],
    public quillString?: string,
    public isCustomQuillString = false,
  ) {}
}
